import React, {Component} from 'react';
import HeaderComponent from '../../Component/HeaderComponent/HeaderComponent.js';

class HeaderContainer extends Component {

  render() {
    return (
      <HeaderComponent active={this.props.active}/>
    )
  }
}


export default HeaderContainer;
